export default {
  SET_DATA_PDF(state, newValue) {
    state.pdfData = newValue
  }
}
